import type { Navigation } from '@/features/navigation/types/navigation';
import { LinksWrapper } from './links-wrapper';

interface Props {
  depthLevel: number;
  submenu: Navigation;
  onMouseEnter: () => void;
}

export const DropdownLinksWrapper = ({
  depthLevel,
  submenu,
  onMouseEnter,
}: Props) => {
  return submenu.children?.map((submenuChildren) => (
    <LinksWrapper
      key={submenuChildren.id}
      depthLevel={depthLevel + 1}
      submenu={submenuChildren}
      onMouseEnter={onMouseEnter}
    />
  ));
};
